module.exports = __webpack_public_path__ + "a6066f0498f16fb093699cd558b5b0ce.svg";